import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import PaymentGateway from './PaymentGateway';
import messages from '../../../locale/messages';
import { restrictUrls } from '../../../helpers/adminPrivileges';

function action({ store, intl }) {
  const title = intl.formatMessage(messages.managePaymentGateWay);

  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  let adminPrivileges = store.getState().account && store.getState().account.privileges;
  let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;
  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }
  // Admin restriction
  if (!restrictUrls('/siteadmin/payment-gateway', adminPrivileges, privileges)) {
    return { redirect: '/siteadmin' };
  }
  return {
    title,
    component: (
      <AdminLayout>
        <PaymentGateway />
      </AdminLayout>
    ),
  };
}

export default action;
